import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SpinerService } from '../../services/spinner/spinner-service';

@Component({
  selector: 'app-spinner',
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  readonly spinner = inject(SpinerService);
}
